/**
 * @generated SignedSource<<2b324230abf23690d47acf017131547b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer$data = {
  readonly showAddToCartButton: boolean | null;
  readonly " $fragmentType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$key = {
  readonly " $data"?: PdpRespSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_viewer",
  "selections": [
    {
      "alias": "showAddToCartButton",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCartAddToCartButton"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCartAddToCartButton\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "13d9a4e995ba4fc3e62a554fea83416a";

export default node;
